var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"top"},[_c('topPage')],1),_c('router-view'),_c('div',{staticClass:"foot"},[_c('foot-page')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }